import styled from 'styled-components';

export const ButtonsBox = styled.div`
  flex-wrap: wrap;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  gap: 1px;
  background-color: gray;

  button {
    border-radius: 0;
    display: inline-flex;
    flex-grow: 1;
    justify-content: center;
    margin: 0.5px;
    margin-collapse: collapse;

    &:last-of-type {
      align-self: flex-start;
    }
  }
`;
